import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type DownloadIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
}

export const DownloadIcon = ({
  size = 16,
  color,
  colorScheme = 'dark',
}: DownloadIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))

  return (
    <svg
      fill='none'
      height={size}
      viewBox='0 0 14 14'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.75 8.75V11.4167C12.75 11.7703 12.6095 12.1094 12.3595 12.3595C12.1094 12.6095 11.7703 12.75 11.4167 12.75H2.08333C1.72971 12.75 1.39057 12.6095 1.14052 12.3595C0.890476 12.1094 0.75 11.7703 0.75 11.4167V8.75M10.0833 5.41667L6.75 8.75L3.41667 5.41667M6.75 8.75V0.75'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
